import Box from 'v2/components/UI/Box';
import { ICardNursery } from 'v2/resources/types/nurseries';
import { IRenderAvailableOrMaintenance, STATUS } from './types';
import Icon from 'v2/components/Icon';
import Text from 'v2/components/UI/Text';
import ButtonBase from 'v2/components/UI/ButtonBase';
import useCardNursery from './hooks/useCardNursery';

const CardNursery: React.FC<ICardNursery> = ({
  type,
  description,
  status,
  system,
  id,
  capacity,
  protocol,
  index,
  cycles,
}) => {
  const {
    openDropdownIndex,
    isMobile,
    isTablet,
    handleOpenDropdown,
    handleNavigatePondId,
    handleNavigateCycle,
  } = useCardNursery();

  const available = status === STATUS.AVAILABLE;
  const isDropdownOpen = openDropdownIndex === index;
  const data = {
    type,
    description,
    status,
    system,
    id,
    capacity,
    protocol,
  };

  const renderAvailableOrMaintenance = ({
    value,
    weight,
    size,
  }: IRenderAvailableOrMaintenance) => {
    if (available) {
      return (
        <Text fontSize={size} fontWeight={weight} color="#2e7d32">
          {value}
        </Text>
      );
    }
    return (
      <Text fontSize={size} fontWeight={weight} color="#e47922">
        {value}
      </Text>
    );
  };

  const renderDescribe = () => {
    if (available) {
      return (
        <Box alignItems="center" width={'100%'} justifyContent="space-between">
          <Box alignItems="center" gap={5}>
            <Icon iconName="VerifiedOutlined" htmlColor="#2e7d32" size={20} />
            <Text>Viveiro está disponível para o uso.</Text>
          </Box>

          <ButtonBase
            alignItems="center"
            justifyContent="center"
            background={'#2e7d3222'}
            width={30}
            height={30}
            borderRadius={100}
            onClick={(e) => {
              e.stopPropagation();
              handleOpenDropdown(index);
            }}
          >
            <Icon iconName="AddOutlined" htmlColor=" #2e7d32" size={24} />
          </ButtonBase>
          {isDropdownOpen && (
            <Box
              position="absolute"
              background={'#fff'}
              border={`1px solid #2e7d32`}
              borderRadius={8}
              zIndex={1000}
              flexDirection="column"
            >
              {cycles.map((cycle) => (
                <ButtonBase
                  onClick={(e) => {
                    e.stopPropagation();
                    handleNavigateCycle(data, cycle);
                  }}
                  fontWeight={600}
                  padding={'12px 20px'}
                  color="#2e7d32"
                >
                  {cycle.code}
                </ButtonBase>
              ))}
            </Box>
          )}
        </Box>
      );
    }
    return (
      <Box alignItems="center" width={'100%'} justifyContent="space-between">
        <Box alignItems="center" gap={5}>
          <Icon iconName="NewReleasesOutlined" htmlColor="#e47922" size={20} />
          <Text>Viveiro em manutenção.</Text>
        </Box>

        <ButtonBase
          alignItems="center"
          justifyContent="center"
          background={'#e4792222'}
          width={30}
          height={30}
          borderRadius={100}
          onClick={() => handleNavigatePondId(id)}
        >
          <Icon
            iconName="KeyboardArrowRightOutlined"
            htmlColor=" #e47922"
            size={26}
          />
        </ButtonBase>
      </Box>
    );
  };

  return (
    <Box
      padding={25}
      gap={15}
      flexDirection="column"
      background={'#fff'}
      borderRadius={16}
      width={'100%'}
      minWidth={300}
      maxWidth={isMobile || isTablet ? '100%' : '32%'}
      marginBottom={'2%'}
      border={available ? 'none' : '0.5px solid #e47922'}
    >
      <Box alignItems="center" width={'100%'} justifyContent="space-between">
        <Box gap={5} alignItems="center">
          <Text fontSize={14} fontWeight={500}>
            {type}
          </Text>
          <Text fontSize={14} fontWeight={500}>
            |
          </Text>
          <Text fontSize={14} fontWeight={500}>
            {system}
          </Text>
        </Box>

        {renderAvailableOrMaintenance({
          value: status,
          weight: 700,
          size: 14,
        })}
      </Box>

      <Box textTransform="uppercase">
        {renderAvailableOrMaintenance({
          value: description,
          weight: 700,
          size: 22,
        })}
      </Box>

      {renderDescribe()}
    </Box>
  );
};
export default CardNursery;
